import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useEffect } from 'react';
import { PersonFilled } from '@zooplus/icons';
import { useAppState } from '../../context/AppContext.js';
import { useTranslations } from '../../translations/index.js';
import Flyout from '../Flyout/Flyout.js';
import styles from './AccountMobileButton.module.css.js';

const ACCOUNT_MIDDLE_BAR_BUTTON_ID = 'srh-account-mbbutton';
const AccountMobileButton = ({ showFlyout, setShowFlyout, onFlyoutClick, }) => {
    const { t } = useTranslations();
    const flyoutRef = useRef(null);
    const flyoutButtonRef = useRef(null);
    const { bundle } = useAppState();
    const primaryIconStyles = bundle === 'bitiba' ? styles.primaryIconBitiba : styles.primaryIcon;
    const mobileFlyOutClickOutsideHandler = useCallback((event) => {
        if (flyoutRef.current &&
            !flyoutRef.current.contains(event.target) &&
            flyoutButtonRef.current &&
            !flyoutButtonRef.current.contains(event.target)) {
            setShowFlyout(false);
        }
    }, [setShowFlyout]);
    const mobileFlyOutHandler = () => {
        if (typeof onFlyoutClick === 'function') {
            onFlyoutClick();
        }
        setShowFlyout((state) => !state);
    };
    useEffect(() => {
        if (showFlyout) {
            document.addEventListener('click', mobileFlyOutClickOutsideHandler);
        }
        return () => {
            if (showFlyout) {
                document.removeEventListener('click', mobileFlyOutClickOutsideHandler);
            }
        };
    }, [showFlyout, mobileFlyOutClickOutsideHandler]);
    return (jsxs(Fragment, { children: [jsxs("button", { id: ACCOUNT_MIDDLE_BAR_BUTTON_ID, onClick: mobileFlyOutHandler, ref: flyoutButtonRef, "aria-haspopup": true, "aria-expanded": showFlyout, "aria-controls": "shopHeaderAccountFlyout", type: "button", className: styles.button, children: [jsx("div", { className: styles.accessibleText, children: t('menu.accessible.description') }), jsx("i", { "aria-hidden": true, className: `${primaryIconStyles} ${showFlyout ? styles.primaryIconWithFlyoutOpen : ''}`, children: jsx(PersonFilled, {}) })] }), jsx(Flyout, { visible: showFlyout, elementRef: flyoutRef, id: "shopHeaderAccountFlyout", labelId: ACCOUNT_MIDDLE_BAR_BUTTON_ID })] }));
};
AccountMobileButton.displayName = 'AccountMobileButton';

export { ACCOUNT_MIDDLE_BAR_BUTTON_ID, AccountMobileButton as default };
//# sourceMappingURL=AccountMobileButton.js.map
